export const renderAppointmentStatus = (status) => {
    if (!status) {
        return ''
    }
    return status.replace(/_/g, ' ')
}

export const renderAppointmentType = (appointmentType) => {
    return appointmentType
}

export const renderAppointmentReason = (appointmentReason) => {
    return appointmentReason
}



// WEBPACK FOOTER //
// ./src/modules/appointment/util/names.js